import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@redux/hooks";
import { useToast } from "@shared-kernel/primary/shared/shadcn/ui/use-toast";
import { resetOnboardProvider } from "@user-management-context/write/application/use-cases/provider-onboarding/onboard-provider-reducer";
import { selectProviderOnboarding } from "@user-management-context/write/application/use-cases/provider-onboarding/selectors/provider-onboarding-selectors";

export const useProviderOnboarding = () => {
  const { toast } = useToast();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { processing } = useAppSelector(selectProviderOnboarding);

  useEffect(() => {
    if (processing === "success") {
      toast({ description: "Votre profil organisation est prêt !" });
      dispatch(resetOnboardProvider());
      navigate("/onboarding");
    } else if (processing === "failed") {
      toast({ description: "Erreur lors de la finalisation de votre profil organisation", variant: "destructive" });
      dispatch(resetOnboardProvider());
    }
  }, [processing, toast, dispatch, navigate]);
};
